import { createBrowserRouter, RouterProvider } from 'react-router';

import { getPath } from '@helsenorge/framework-utils/hn-page';

import EventSubscriber from '../event-subscriber';
import RedirectProvider from '../redirect-provider';
import { routes } from './routes';

const PersonvelgerPage: React.FC = () => {
  const router = createBrowserRouter(routes, { basename: '/' + getPath() });
  return (
    <RedirectProvider>
      <EventSubscriber>
        <RouterProvider router={router} />
      </EventSubscriber>
    </RedirectProvider>
  );
};

export default PersonvelgerPage;
